import type { HttpRequest } from '../http.js'

const geminiHost = 'generativelanguage.googleapis.com'

export interface GeminiRequestParams {
  host?: string
  path: string
  method?: string
  body?: Record<string, unknown>
  apiKey?: string
  timeout?: number
}

export type GeminiRequestAPI = (params: GeminiRequestParams) => Promise<unknown>

export function createRequestAPI(httpRequest: HttpRequest): GeminiRequestAPI {
  return async ({
    host = geminiHost,
    path,
    method = 'POST',
    body = {},
    apiKey,
    timeout = 60000,
  }) => {
    if (!apiKey) {
      throw new Error('apiKey is required for Gemini API calls')
    }

    const pathWithKey = path.includes('?') ? `${path}&key=${apiKey}` : `${path}?key=${apiKey}`

    const options = {
      protocol: 'https' as const,
      options: {
        host,
        path: pathWithKey,
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout,
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
    }

    const resp = await httpRequest(options)

    if (resp.statusCode >= 400) {
      throw new Error(`Gemini API error: ${resp.statusCode} - ${JSON.stringify(resp.body)}`)
    }

    return JSON.parse(resp.body)
  }
}
